/* Polsk katalog for locale-invoice-live.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'actionApproval.approve': 'Zatwierdź',
  'actionApproval.approveAction': 'Zatwierdź: {action}',
  'live.reviewTitle': 'Sprawdź fakturę',
  'live.reviewInvoice': 'Sprawdź fakturę poniżej przed zatwierdzeniem.',
  'live.deliveryLabel': 'Wyślij jako',
  'live.approveSend': 'Zatwierdź i wyślij',
  'live.approveIssue': 'Zatwierdź i utwórz',
  'actionApproval.label.send_offer': 'Wyślij ofertę',
  'actionApproval.label.send_credit_note': 'Wyślij fakturę korygującą',
  'actionApproval.label.send_reminder': 'Wyślij przypomnienie o płatności bez opłaty',
  'actionApproval.label.post_purchase': 'Zarejestruj i zaksięguj zakup',
  'actionApproval.label.reverse_purchase': 'Wycofaj zakup',
  'actionApproval.label.post_manual_voucher': 'Zaksięguj dowód księgowy',
  'actionApproval.label.reverse_voucher': 'Wycofaj dowód księgowy',
  'actionApproval.label.approve_payroll_run': 'Zatwierdź i zaksięguj listę płac',
  'actionApproval.label.reverse_payroll_run': 'Wycofaj listę płac',
  'actionApproval.label.record_payroll_submission': 'Potwierdź, że A-melding została złożona poza Plumme',
  'actionApproval.label.close_accounting_year': 'Zatwierdź i zamknij rok obrotowy',
  'actionApproval.label.reopen_accounting_year': 'Otwórz ponownie rok obrotowy',
  'actionApproval.label.delete_invoice_drafts': 'Usuń szkice faktur',
  'actionApproval.label.delete_purchase_draft': 'Usuń szkic zakupu',
  'actionApproval.label.delete_payroll_draft': 'Usuń szkic listy płac',
  'actionApproval.label.delete_project': 'Usuń projekt',
  'actionApproval.label.invite_business_member': 'Zaproś użytkownika do firmy',
  'actionApproval.label.remove_business_member': 'Usuń dostęp użytkownika do firmy',
  'actionApproval.label.cancel_business_invite': 'Wycofaj zaproszenie',
  'live.reading': 'Odczytuję formularz i wybieram następny krok …',
  'live.open_editor': 'Otwieram edytor faktur …',
  'live.set_layout': 'Zmieniam widok …',
  'live.set_customer': 'Wybieram klienta …',
  'live.set_field': 'Wypełniam pole …',
  'live.set_line': 'Wypełniam pozycję faktury …',
  'live.remove_line': 'Usuwam pozycję faktury …',
  'live.open_customer_form': 'Przygotowuję nowego klienta …',
  'live.open_product_form': 'Przygotowuję nowy produkt …',
  'live.review': 'Otwieram podgląd …',
  'live.request_save': 'Przygotowuję do zatwierdzenia …',
  'live.finish': 'Sprawdzam wynik …',
  'live.ask_user': 'Potrzebne wyjaśnienie …',
  'live.approval': 'Czekam, aż sprawdzisz i zapiszesz formularz.',
  'live.customerApproval': 'Sprawdź nowego klienta w formularzu. Gdy zapiszesz, będę kontynuować fakturę.',
  'live.productApproval': 'Sprawdź nowy produkt, cenę i VAT w formularzu. Gdy zapiszesz, będę kontynuować fakturę.',
  'live.customerSaved': 'Klient został zapisany. Kontynuuję fakturę.',
  'live.productSaved': 'Produkt został zapisany. Kontynuuję fakturę.',
  'live.cancelled': 'Tworzenie zostało anulowane. Praca nad fakturą jest wstrzymana.',
  'live.notApplied': 'Pole nie zostało zaktualizowane zgodnie z oczekiwaniami. Zatrzymałem się, abyś mógł sprawdzić formularz.',
  'live.limit': 'Osiągnąłem limit liczby kroków. Sprawdź formularz i opisz, co pozostało.',
  'live.done.open_editor': 'Edytor faktur jest otwarty.',
  'live.done.set_layout': 'Widok został zmieniony.',
  'live.done.set_customer': 'Klient został wybrany.',
  'live.done.set_field': 'Pole zostało wypełnione i sprawdzone.',
  'live.done.set_line': 'Pozycja faktury została wypełniona i sprawdzona.',
  'live.done.remove_line': 'Pozycja faktury została usunięta.',
  'control.productRequired': 'Produktu nie ma w aktywnym rejestrze produktów.',
  'control.intro': 'Opisz, jaką fakturę chcesz utworzyć. Wypełnię formularz i mogę utworzyć potrzebnych klientów i produkty. Wyraźnie poproś o wystawienie i wysłanie, gdy mam dokończyć fakturę.',
  'live.create_customer': 'Zapisuję klienta …',
  'live.create_product': 'Zapisuję produkt …',
  'live.issue_invoice': 'Wystawiam fakturę …',
  'live.send_invoice': 'Wystawiam i wysyłam fakturę …',
  'live.finished': 'Wypełnianie zakończone. Zmiany zostały sprawdzone w formularzu faktury.',
  'live.clarification': 'Opisz, co chcesz dalej zrobić z fakturą.',
  'live.invoiceIssued': 'Faktura została wystawiona. Nie została wysłana.',
  'live.invoiceSent': 'Faktura została wysłana e-mailem.',
  'live.emailRequired': 'Do wysłania potrzebuję adresu e-mail klienta i adresu e-mail nadawcy w ustawieniach firmy. Podaj adres odbiorcy razem z nowym poleceniem wysłania.',
  'live.authorizationRequired': 'Napisz wyraźnie, co chcesz utworzyć lub wysłać.',
  'live.deliveryUncertain': 'Próba wysłania została już podjęta. Sprawdź status wysyłki na liście faktur przed ponowną próbą, aby klient nie otrzymał faktury dwukrotnie.',
  'live.deliveryNotSent': 'Faktura została wystawiona, ale wysyłka nie została potwierdzona. Sprawdź status wysyłki na liście faktur.',
  'live.ambiguousRecord': 'Kilku klientów lub produktów ma tę samą nazwę. Najpierw wybierz właściwy wpis.',
  'live.actionBusy': 'Zapisywanie lub wysyłanie już trwa.',
  'appControl.changed': 'Strona lub firma uległa zmianie. Sprawdź stronę i poproś mnie o kontynuację.',
  'appControl.unsupported': 'Z tego elementu sterującego musisz skorzystać bezpośrednio na stronie.',
  'appControl.authorization': 'Powiedz mi, jakie działanie mam wykonać.',
  'appControl.manual': 'Dokończ ten krok bezpośrednio na stronie, a wtedy będę mógł kontynuować.',
  'appControl.option': 'Ta opcja nie jest dostępna w tym polu.',
  'appControl.repeated': 'Próba wykonania tego działania została już podjęta. Sprawdź wynik na stronie, zanim przejdziesz dalej.',
  'actionApproval.title': 'Zatwierdź działanie',
  'actionApproval.body': 'Sprawdź działanie i dane poniżej. Zatwierdzenie dotyczy tylko tego kroku.',
  'actionApproval.confirm': 'Zatwierdź i wykonaj',
  'actionApproval.proposal': 'Proponowane działanie',
  'actionApproval.context': 'Dane, których dotyczy działanie',
  'actionApproval.cancel': 'Anuluj',
  'actionApproval.mcp': 'Działanie od połączonej AI',
  'actionApproval.failed': 'Nie udało się wykonać działania. Pobierz nową propozycję i spróbuj ponownie.',
  'actionApproval.loading': 'Wczytywanie działania ...',
  'actionApproval.done': 'Działanie zostało wykonane.',
  'actionApproval.business': 'Firma',
  'actionApproval.writeScope': 'AI może proponować działania zapisu. Każde działanie musi zostać zatwierdzone przez Ciebie w Plumme, zanim zostanie wykonane.',
  'actionApproval.label.create_invoice_draft': 'Utwórz szkic faktury',
  'actionApproval.label.register_invoice_payment': 'Zarejestruj płatność faktury',
  'actionApproval.label.save_draft': 'Zapisz szkic',
  'actionApproval.label.send_invoice': 'Wyślij fakturę',
  'actionApproval.label.issue_invoice': 'Wystaw fakturę',
  'actionApproval.label.create_customer': 'Utwórz klienta',
  'actionApproval.label.create_product': 'Utwórz produkt',
  'actionApproval.label.invoice': 'Faktura',
  'actionApproval.label.invoiceId': 'ID faktury',
  'actionApproval.label.customer': 'Klient',
  'actionApproval.label.customerName': 'Nazwa klienta',
  'actionApproval.label.currency': 'Waluta',
  'actionApproval.label.amount': 'Kwota',
  'actionApproval.label.date': 'Data',
  'actionApproval.label.dueDate': 'Termin płatności',
  'actionApproval.label.lines': 'Pozycje',
  'actionApproval.label.quantity': 'Ilość',
  'actionApproval.label.unitPrice': 'Cena jednostkowa',
  'actionApproval.label.vatRate': 'Stawka VAT',
  'actionApproval.label.description': 'Opis',
  'actionApproval.label.business': 'Firma',
  'actionApproval.label.expires': 'Ważne do',
  'actionApproval.label.recipientEmail': 'Odbiorca',
  'actionApproval.label.fields': 'Pola',
  'actionApproval.label.label': 'Nazwa',
  'actionApproval.label.value': 'Wartość',
  'actionApproval.label.text': 'Dane na stronie',
  'actionApproval.label.action': 'Działanie',
  'actionApproval.label.click': 'Kliknij',
  'actionApproval.label.fill': 'Wypełnij',
  'actionApproval.label.select': 'Wybierz',
  'actionApproval.label.check': 'Zmień wybór',
  'actionApproval.label.checked': 'Wybrano',
  'actionApproval.label.post': 'Zaksięguj',
  'actionApproval.label.approve': 'Zatwierdź listę płac',
  'actionApproval.label.close_year': 'Zatwierdź i zamknij rok obrotowy',
  'actionApproval.label.reopen_year': 'Otwórz ponownie rok obrotowy',
  'actionApproval.label.manage_members': 'Zmień uprawnienia',
  'actionApproval.label.delete': 'Usuń lub wycofaj',
  'actionApproval.label.submit': 'Złóż',
  'actionApproval.label.expense': 'Zakup',
  'actionApproval.label.supplier': 'Dostawca',
  'actionApproval.label.year': 'Rok',
  'actionApproval.label.records': 'Wpisy',
});
